<template>

    <div class="post-wrapper conversation card card-shadow" :class="{'compact': displayMode === 'small', 'unread' : topic.unread, 'single-topic': singleTopic}">

        <topic-scroll-to-newest :singleTopic="singleTopic" :itemHighlighted="itemHighlighted" :topic="topic" :viewType="viewType"></topic-scroll-to-newest>

        <topic-helpdesk-status-switch :topic="topic"></topic-helpdesk-status-switch>

        <moodview-topic-top :topic="topic" :viewType="viewType"></moodview-topic-top>

        <!-- post top -->
        <!--<div class="post-top" v-if="topic.status == 'invisible' && topic.user().id == user.id">-->
        <div class="post-top">
            <div class="card-inner flex">
                <div class="flex-1 flex-no-padding">
                    <topic-user-icon :topic="topic"></topic-user-icon>
                </div>
                <div class="flex-16 flex-no-padding">
                    <div class="post-top-content">
                        <topic-top-meta :topic="topic" :showUserCredentials="false" :viewType="viewType" :singleTopic="singleTopic"></topic-top-meta>
                        <div class="post-content normal-text" v-if="!expandedTopic">
                            <div v-if="topic.status == 'invisible' && topic.user().id != user.id && topic.liked_by_me === false" class="general-button inline-button"
                                    :class="[{'font-blue' : topic.liked_by_me}]"
                                    @click="likePost({id: topic.post_id, bool: !topic.liked_by_me, model: topic.plural, object: topic, closed: topic.closed})" style="margin-top: 15px;">{{ translations['forum.welcome_user'] }}
                            </div>
                            <p v-else class="light-text bold-text">Je hebt {{ topic.user().name }} welkom geheten!</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- post likes & comments count -->
        <topic-stats :likeIcon="'none'" :topic="topic" :displayMode="displayMode"></topic-stats>

    </div>
</template>

<script>
    //mixins
    import Feed from '../../mixins/Feed.js'
    import Global from '../../mixins/Global.js'
    import Topic from '../../mixins/Topic.js'

    // Import the like and comment models. Handle the commit to the store and then to -> action.
    export default {
        mixins: [Feed, Global, Topic],
    }
</script>

<style scoped>

</style>